import { formatNumberWithCommas, persianToEnglishDigits } from '../utilities'

export const handleIbanChange = (
    value: string,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
) => {
    value = persianToEnglishDigits(value)
    value = value.replace(/[^0-9]/g, '')

    if (value) {
        value = `IR${value}`
    } else {
        value = 'IR'
    }

    if (value.length > 26) {
        value = value.slice(0, 26)
    }

    setFieldValue('issuerIban', value)
}

export const handleFormattedChange = (
    value: string,
    setFieldValue: (
        field: string,
        value: any,
        shouldValidate?: boolean
    ) => void,
    fieldName: string
) => {
    const formattedValue = formatNumberWithCommas(value)
    setFieldValue(fieldName, value)
    return formattedValue
}
